import { SearchQuery } from "../../code/search-query/search-query";
import ManagedGridView from "../../controls/ManagedGridView";
import { getTrainings } from "../../repository/data.repository";
import { createGridRequest } from "../../hooks/useGridRequest";
import {
  trainingsViewColumns,
  mapTrainingsViewQuery,
  trainingsSearchSchema,
} from "./TrainingsView.default";
import { useSelector } from "../../store/store";
import { authorizeSelectors } from "../../store/authorize";

export interface TrainingsViewProps {
  readonly trigger?: string;
  readonly onAction?: (key: string, record: any) => void;
  readonly onSearch?: (searchQuery: SearchQuery) => void;
}

function TrainingsView(props: TrainingsViewProps) {
  const permissions = useSelector(authorizeSelectors.permissions);

  return (
    <ManagedGridView
      trigger={props.trigger}
      columns={trainingsViewColumns}
      schema={trainingsSearchSchema}
      mapQuery={mapTrainingsViewQuery}
      onSearch={props.onSearch}
      request={createGridRequest(getTrainings, { retry: true })}
      pageSize={100}
      actions={[
        {
          key: "manage",
          label: "Manage",
          // Manage doubles as the read surface — view-gated by design; the actions inside are edit-gated.
          disabled: !permissions.can("Trainings", "view"),
          handler: (key, record) => props.onAction?.(key, record),
        },
        {
          key: "delete",
          label: "Delete",
          danger: true,
          disabled: !permissions.can("Trainings", "delete"),
          handler: (key, record) => props.onAction?.(key, record),
        },
      ]}
    />
  );
}

export default TrainingsView;
